import React, { useState } from 'react';
import PropTypes from 'prop-types';

const Avatar = ({ image, large, onClick }) => {
  const [hover, setHover] = useState(false);

  const styles = {
    image: {
      width: 46,
      height: 46,
      borderRadius: '100%',
      overflow: 'hidden',
      backgroundColor: '#e5e5e5',
      textAlign: 'center',
      color: '#ccc',
      marginRight: 0
    },
    large_image: {
      height: '100%',
      cursor: 'pointer',
      width: '100px',
      height: '100px',
      borderRadius: '100%',
      backgroundColor: '#fff',
      border: '1px solid #e5e5e5',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      position: 'relative',
      fontSize: 98,
      display: 'inline-block',
      textAlign: 'center',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased'
    },
    placeholder: {
      width: '100px',
      height: '100px',
      padding: '0 3px 0 3px',
      borderRadius: '100%',
      backgroundColor: '#e5e5e5',
      fontSize: 40,
      textAlign: 'center',
      color: '#ccc'
    },
    large_placeholder: {
      color: '#cccccc',
      cursor: 'pointer',
      width: '100px',
      height: '100px',
      borderRadius: '100%',
      backgroundColor: '#e5e5e5',
      border: '1px solid #e5e5e5',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      position: 'relative',
      fontSize: 98,
      display: 'inline-block',
      textAlign: 'center',
      textRendering: 'auto',
      WebkitFontSmoothing: 'antialiased'
    },
    hover_edit_icon: {
      cursor: 'pointer',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      fontSize: '24px',
      color: '#fff'
    },
    hover_edit_background: {
      cursor: 'pointer',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'rgba(0, 0, 0, 0.7)',
      borderRadius: '100%',
      width: '100px',
      height: '100px',
      position: 'absolute',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  };

  return image
    ? (large && (
        <div
          onClick={onClick}
          onMouseEnter={() => setHover(!hover)}
          onMouseLeave={() => setHover(!hover)}
          style={{
            margin: '0 15px 0 0',
            position: 'relative'
          }}
        >
          <img src={image} style={styles.large_image} />
          {hover ? (
            <div style={styles.hover_edit_background}>
              <i className='mdi mdi-pencil' style={styles.hover_edit_icon} />
            </div>
          ) : null}
        </div>
      )) || (
        <div>
          <div
            style={{
              ...styles.image,
              overflow: 'hidden',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundImage: `url(${image})`
            }}
          />
        </div>
      )
    : (large && (
        <div
          onClick={onClick}
          onMouseEnter={() => setHover(!hover)}
          onMouseLeave={() => setHover(!hover)}
          style={{
            margin: '0 15px 0 0',
            position: 'relative'
          }}
        >
          <i className='mdi mdi-account' style={styles.large_placeholder} />
          {hover ? (
            <div style={styles.hover_edit_background}>
              <i className='mdi mdi-pencil' style={styles.hover_edit_icon} />
            </div>
          ) : null}
        </div>
      )) || (
        <i
          className='mdi mdi-account'
          style={hover ? styles.placeholder_hover : styles.placeholder}
        />
      );
};

Avatar.propTypes = {
  image: PropTypes.string,
  large: PropTypes.bool,
  onClick: PropTypes.func
};

export default Avatar;
